


































































































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { update_agency_invoice } from '@/api/invoice';
import { translateComponentResource } from '@/utils/index';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'InvoiceAgencyDetailOperationInitiallyConfirm',
})
export default class InvoiceAgencyDetailOperationInitiallyConfirm extends Vue {
  public static readonly invoiceAgencyOperationInitiallyConfirmEvent =
    'invoice-agency-operation-initially-confirm';
  @Prop({ default: true }) flat!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true }) currency!: string;
  private valid = false;
  private operator = '';
  private operatorRules: ((v: string) => boolean | string)[] = [];
  private discrepancies: update_agency_invoice.InitiallyConfirm.Discrepancy[] = [];
  private discrepancyTitleRules: ((v: string) => boolean | string)[] = [];
  private note = '';
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get canInitiallyConfirm() {
    return this.valid;
  }

  mounted() {
    this.loadDefaultOperatedBy();
    this.loadRules();
  }

  private loadDefaultOperatedBy() {
    this.operator = UserModule.defaultOperatedBy;
  }

  private loadRules() {
    this.operatorRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Operated by'),
        }) as string),
    ];
    this.discrepancyTitleRules = [
      (v: string) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Item'),
        }) as string),
    ];
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForReset() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.reset();
    };
    this.dialog = true;
  }

  private showDialogForInitiallyConfirm() {
    this.dialogTextTitle = `${this.translateComponentResource('Confirm')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.initiallyConfirm();
    };
    this.dialog = true;
  }

  private reset() {
    (this.$refs.form as any).reset();
  }

  private addDiscrepancy() {
    for (let i = 0; i < this.discrepancies.length; i++) {
      if (!this.discrepancies[i].title) {
        this.$toast.error(
          `${this.$t('Adjust discrepancy')}${i + 1}: ${this.$t(
            '{msg} is required',
            {
              msg: this.$t('Item'),
            }
          )}`,
          {
            icon: 'mdi-alert',
          }
        );
        return;
      }
    }

    this.discrepancies.push({
      title: '',
      currency: this.currency,
      amount: 0,
    });
  }

  private removeDiscrepancy(discrepancyIndex: number) {
    if (discrepancyIndex >= 0 && discrepancyIndex < this.discrepancies.length) {
      this.discrepancies.splice(discrepancyIndex, 1);
    }
  }

  private initiallyConfirm() {
    this.$emit(
      InvoiceAgencyDetailOperationInitiallyConfirm.invoiceAgencyOperationInitiallyConfirmEvent,
      {
        operatorName: this.operator,
        initiallyConfirm: {
          discrepancies: this.discrepancies,
        },
        note: this.note,
      } as Partial<update_agency_invoice.Request>
    );
  }

  private translateComponentResource(resource: string) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource
    );
  }
}
